// extracted by mini-css-extract-plugin
export default {"assetButton":"NapCarPassLogo-module-assetButton","root":"NapCarPassLogo-module-root","logoNap":"NapCarPassLogo-module-logoNap","logoCarPass":"NapCarPassLogo-module-logoCarPass"};